/**
 * @generated SignedSource<<7030f773dfb1eb99427c19a319d0c886>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalWorkspaceTemplateSelectorApplyTemplateMutation$variables = {
  signalWorkspaceId: string;
  templateId: string;
};
export type SignalWorkspaceTemplateSelectorApplyTemplateMutation$data = {
  readonly signalWorkspace: {
    readonly applyTemplate: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_SignalWorkspace" | "WorkspaceSignalEditMainContent_Signal" | "WorkspaceSignalEditMainEditedInfo_Signal" | "WorkspaceSignalEditMainPrioritySelector_Signal">;
    };
  };
};
export type SignalWorkspaceTemplateSelectorApplyTemplateMutation = {
  response: SignalWorkspaceTemplateSelectorApplyTemplateMutation$data;
  variables: SignalWorkspaceTemplateSelectorApplyTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalWorkspaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "templateId",
    "variableName": "templateId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalWorkspaceTemplateSelectorApplyTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "applyTemplate",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignalWorkspaceTemplateSelector_SignalWorkspace"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainPrioritySelector_Signal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainEditedInfo_Signal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainContent_Signal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignalWorkspaceTemplateSelectorApplyTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "applyTemplate",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "descriptionFiles",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FilePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "thumbnail",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "descriptionImages",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalWorkspaceTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoString",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formattedBody",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBySessionId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02f162cde24c33e543c3d264ad5255f7",
    "id": null,
    "metadata": {},
    "name": "SignalWorkspaceTemplateSelectorApplyTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation SignalWorkspaceTemplateSelectorApplyTemplateMutation(\n  $signalWorkspaceId: ID!\n  $templateId: ID!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    applyTemplate(templateId: $templateId) {\n      id\n      ...SignalWorkspaceTemplateSelector_SignalWorkspace\n      ...WorkspaceSignalEditMainPrioritySelector_Signal\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n      ...WorkspaceSignalEditMainContent_Signal\n    }\n  }\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_files on File {\n  ...LinkedContent_files\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_files on File {\n  id\n  name\n  type\n  url\n  ...LinkedFileItem_file\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedFileItem_file on File {\n  id\n  name\n  ...FileIcon_File\n  pages {\n    id\n  }\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate on SignalWorkspaceTemplate {\n  id\n  name\n}\n\nfragment SignalWorkspaceTemplateSelector_SignalWorkspace on SignalWorkspace {\n  id\n  updatedBy {\n    __typename\n    id\n  }\n  body\n  title\n  descriptionFiles {\n    __typename\n    id\n  }\n  descriptionImages {\n    __typename\n    id\n  }\n  template {\n    id\n    name\n    ...SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate\n  }\n}\n\nfragment WorkspaceSignalEditMainContent_Signal on SignalWorkspace {\n  id\n  title\n  body\n  formattedBody\n  updatedBySessionId\n  ...WorkspaceSignalLinkedContent_signal\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceSignalEditMainPrioritySelector_Signal on SignalWorkspace {\n  id\n  priority\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalLinkedContent_signal on SignalWorkspace {\n  id\n  descriptionImages {\n    id\n    ...LinkedContentInput_images\n  }\n  descriptionFiles {\n    id\n    url\n    name\n    type\n    ...LinkedContentInput_files\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "b703eb101e5b8b879c4bde1c8bb67542";

export default node;
